import EntityType from "../enum/EntityType";
import PermissionName from "../enum/PermissionName";
import PermissionType from "../enum/PermissionType";

type EntityTypesSupportingPermissions =
  | EntityType.ACTIVITY
  | EntityType.COMPANY
  | EntityType.DEAL
  | EntityType.PERSON
  | EntityType.TRIP;

const ENTITY_TYPES_SUPPORTING_PERMISSIONS: EntityType[] = [
  EntityType.ACTIVITY,
  EntityType.COMPANY,
  EntityType.DEAL,
  EntityType.PERSON,
  EntityType.TRIP,
];

export const supportsPermissions = (
  entityType: EntityType
): entityType is EntityTypesSupportingPermissions =>
  ENTITY_TYPES_SUPPORTING_PERMISSIONS.includes(entityType);

const permissionForEntityTypeMap: Record<
  EntityTypesSupportingPermissions,
  Record<PermissionType, PermissionName>
> = {
  [EntityType.ACTIVITY]: {
    [PermissionType.CREATE]: PermissionName.ACTIVITY_CREATE,
    [PermissionType.DELETE]: PermissionName.ACTIVITY_DELETE,
    [PermissionType.READ]: PermissionName.ACTIVITY_READ,
    [PermissionType.UPDATE]: PermissionName.ACTIVITY_UPDATE,
  },
  [EntityType.COMPANY]: {
    [PermissionType.CREATE]: PermissionName.COMPANY_CREATE,
    [PermissionType.DELETE]: PermissionName.COMPANY_DELETE,
    [PermissionType.READ]: PermissionName.COMPANY_READ,
    [PermissionType.UPDATE]: PermissionName.COMPANY_UPDATE,
  },
  [EntityType.DEAL]: {
    [PermissionType.CREATE]: PermissionName.DEAL_CREATE,
    [PermissionType.DELETE]: PermissionName.DEAL_DELETE,
    [PermissionType.READ]: PermissionName.DEAL_READ,
    [PermissionType.UPDATE]: PermissionName.DEAL_UPDATE,
  },
  [EntityType.PERSON]: {
    [PermissionType.CREATE]: PermissionName.PERSON_CREATE,
    [PermissionType.DELETE]: PermissionName.PERSON_DELETE,
    [PermissionType.READ]: PermissionName.PERSON_READ,
    [PermissionType.UPDATE]: PermissionName.PERSON_UPDATE,
  },
  [EntityType.TRIP]: {
    [PermissionType.CREATE]: PermissionName.TRIPS_CREATE,
    [PermissionType.DELETE]: PermissionName.TRIPS_DELETE,
    [PermissionType.READ]: PermissionName.TRIPS_READ,
    [PermissionType.UPDATE]: PermissionName.TRIPS_CREATE,
  },
};

const hasPermissionForEntityType = (
  permissionChecker: (permissionName: PermissionName) => boolean,
  permissionType: PermissionType,
  entityType: EntityTypesSupportingPermissions
) => {
  const permissionName = permissionForEntityTypeMap[entityType]?.[permissionType];
  if (!permissionName) {
    return true;
  }

  return permissionChecker(permissionName);
};

export default hasPermissionForEntityType;
